<template>
  <div id="app">
    <!-- 前台页面显示Header和Footer -->
    <template v-if="!isAdminRoute">
      <Header />
      <main class="main-content">
        <router-view v-slot="{ Component }">
          <transition name="fade" mode="out-in">
            <component :is="Component" />
          </transition>
        </router-view>
      </main>
      <Footer />
      <FloatingToolbar />
    </template>
    
    <!-- 后台管理页面直接渲染 -->
    <template v-else>
      <router-view />
    </template>
  </div>
</template>

<script setup>

import { computed, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import Header from '@/components/layout/Header.vue'
import Footer from '@/components/layout/Footer.vue'
import FloatingToolbar from '@/components/common/FloatingToolbar.vue'
import { useSEO } from '@/composables/useSEO'

const route = useRoute()

// 初始化SEO（仅在前台页面）
onMounted(() => {
  if (!route.path.startsWith('/admin')) {
    useSEO()
  }
})

// 判断是否为后台管理路由
const isAdminRoute = computed(() => {
  return route.path.startsWith('/admin')
})


// 监听语言变化事件并强制更新组件
window.addEventListener('languageChanged', () => {
  // 通过改变一个响应式数据来触发重新渲染
  if (typeof window.languageVersion !== 'undefined') {
    window.languageVersion++;
  } else {
    window.languageVersion = 1;
  }
});</script>

<style>
@import '@/assets/styles/global.css';

#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.main-content {
  flex: 1;
}
</style>
